import { AlertColor } from '@mui/material/Alert'
import type { ReactElement, ReactNode } from 'react'
import type { NavigateFunction } from 'react-router-dom'
import { showNotification } from 'src/components/common/toastNotification/NotificationProvider'
import { DEFAULT_AUTO_HIDE_DURATION } from 'src/constants/notification.constants'
import { TOAST_VARIANTS } from 'src/constants/toast.constants'

export type ToastType = (typeof TOAST_VARIANTS)[keyof typeof TOAST_VARIANTS]

export interface IToastNotification {
  message: string | ReactNode | ((navigate: NavigateFunction) => ReactElement)
  navigate?: NavigateFunction
  options?: { autoClose?: number | false }
  type: ToastType
}

const toastTypeToAlertColor: Record<ToastType, AlertColor> = {
  [TOAST_VARIANTS.ERROR]: 'error',
  [TOAST_VARIANTS.SUCCESS]: 'success',
  [TOAST_VARIANTS.WARNING]: 'warning',
}

export const showToast = ({
  message,
  navigate,
  options,
  type,
}: IToastNotification): void => {
  const autoHideDuration =
    typeof options?.autoClose === 'number'
      ? options.autoClose
      : options?.autoClose === false
        ? undefined
        : DEFAULT_AUTO_HIDE_DURATION
  const persist = options?.autoClose === false

  // Handle component functions by calling them with navigate function
  const resolvedMessage: string | ReactNode =
    typeof message === 'function' && navigate
      ? message(navigate)
      : (message as string | ReactNode)

  showNotification({
    message: resolvedMessage,
    options: { autoHideDuration, persist },
    severity: toastTypeToAlertColor[type],
  })
}
